import { asContainer } from 'lib/container'

import { Error } from 'components/Error'

export const container = asContainer<{}>()({
	Running: () => <Error />,
})
